import { useEffect, useState } from "react";
import SelectBox from "components/elements/selectBox";
import { connect } from "react-redux";
import { getListUsers } from "actions/userActions";

const SelectStaff = ({ getListUsers, onChange }) => {
    const [staffs, setStaffs] = useState([]);
    const [staff, setStaff] = useState("");

    useEffect(() => {
        getListUsers(1, 9999).then((data) => {
            setStaffs(data?.listusers?.map((staff) => ({ value: staff?._id, label: staff.email + " - " + staff?.name })) || []);
        });
    }, [getListUsers]);

    return (
        <SelectBox
            options={staffs}
            name="filter_user"
            placeholder="Select User"
            value={staff || ""}
            onChange={(data) => {
                setStaff(data.value || "");
                onChange?.(data.value || "");
            }}
        />
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = { getListUsers };

export default connect(mapStateToProps, mapDispatchToProps)(SelectStaff);
